import { __extends } from "tslib";
import React, { createContext } from 'react';
import throttle from 'lodash/throttle';
import { withMobileContext } from '../../Context';
export var ScreenSizeContext = createContext(0);
ScreenSizeContext.displayName = 'ScreenSizeContext';
export var DEFAULT_SIZE = {
    desktop: { width: 1024, height: 786 },
    mobile: { width: 375, height: 500 },
};
var THROTTLE_TIMEOUT = 500;
var THROTTLE_OPTIONS = { trailing: true };
var ScreenSizeContextProvider = /** @class */ (function (_super) {
    __extends(ScreenSizeContextProvider, _super);
    function ScreenSizeContextProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            container: _this.getInitialContainer(),
        };
        _this.updateContainerSize = throttle(function () {
            var container = _this.state.container;
            var onUpdatedDims = _this.props.onUpdatedDims;
            var newContainer = {
                width: window.innerWidth,
            };
            if (container !== undefined && container.width === newContainer.width) {
                return;
            }
            _this.setState({ container: newContainer }, function () {
                onUpdatedDims && onUpdatedDims(_this.state.container);
            });
        }, THROTTLE_TIMEOUT, THROTTLE_OPTIONS);
        return _this;
    }
    ScreenSizeContextProvider.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.updateContainerSize);
        this.updateContainerSize();
    };
    ScreenSizeContextProvider.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.updateContainerSize);
    };
    ScreenSizeContextProvider.prototype.render = function () {
        var _a, _b;
        var children = this.props.children;
        var width = (_b = (_a = this.state.container) === null || _a === void 0 ? void 0 : _a.width, (_b !== null && _b !== void 0 ? _b : 0));
        return (React.createElement(ScreenSizeContext.Provider, { value: width }, children));
    };
    ScreenSizeContextProvider.prototype.isServerRendering = function () {
        return typeof document === 'undefined' || typeof window === 'undefined';
    };
    ScreenSizeContextProvider.prototype.getDefaultSize = function () {
        var isMobile = this.props.isMobile;
        return DEFAULT_SIZE[isMobile ? 'mobile' : 'desktop'];
    };
    ScreenSizeContextProvider.prototype.getInitialContainer = function () {
        var prevLoadDims = this.props.prevLoadDims;
        if (prevLoadDims && prevLoadDims.width > 0) {
            return prevLoadDims;
        }
        return this.getDefaultSize();
    };
    ScreenSizeContextProvider.displayName = 'ScreenSizeContextProvider';
    return ScreenSizeContextProvider;
}(React.Component));
export default withMobileContext(ScreenSizeContextProvider);
//# sourceMappingURL=ScreenSizeContext.js.map